define('Cart.Fix', [
    'Cart.AddToCart.FixAddingTwice'
],
function CartFix(

) {
    'use strict';

    return {};
});

